import React, {Component} from "react";
import {w3cwebsocket as W3CWebSocket} from "websocket";
import {Default} from "./templates/default";
import {RetailSummit2021} from "./templates/RetailSummit2021/index";
import {Legacy} from "./templates/legacy";

const moment = require('moment-timezone');
const pingIntervalSeconds = 5;
const latencyBuckets = [0.005, 0.01, 0.025, 0.05, 0.075, 0.1, 0.25, 0.5, 0.75, 1, 2.5, 5, 7.5, 10, 15, 20, Number.MAX_VALUE];
let latencyHistogram;

class Semaphore extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {},
            connectionStatus: 'Unknown',
            metadata: {},
            operationId: props.match.params.operationId,
            err: null,
            wsStatus: null,
            wsError: null,
            initialized: false,
            template: props.template || 'default'
        }
    }

    componentDidMount() {
        let monitoringTimer = setInterval(() => {
            this.updateMonitoring();
        }, 60 * 1000);

        let timer = setInterval(() => {
            this.checkState();
        }, 5 * 1000);

        let heartbeatTimer = setInterval(() => {
            let {client, lastPong} = this.state;

            if (client && client.readyState === 1 &&
                (!lastPong || lastPong.getTime() < new Date().getTime() - pingIntervalSeconds * 1000)) {

                client.send('ping');
            }
        }, 1000);

        let currentTimeTimer = setInterval(() => {
            this.setState({currentTime: new Date()});
        }, 1000);

        this.setState({monitoringTimer, timer, heartbeatTimer, currentTimeTimer});

        this.init();
    }

    init() {
        if (this.state.operationId.startsWith("demo")) {
            fetch('/' + this.state.operationId + '/occupancy.json')
                .then(response => response.json())
                .then(data => this.setState({data: data, connectionStatus: "OK"}));
            fetch('/' + this.state.operationId + '/operationMeta.json')
                .then(response => response.json())
                .then(metadata => {
                    let language = this.props.language || metadata.country;

                    this.setState({metadata, language});
                });
        } else {
            fetch('/operationMeta?id=' + this.state.operationId, {
                headers: {'Authorization': this.props.token}
            })
                .then(response => response.json())
                .then(metadata => {
                    this.setState({err: metadata.err});
                    if (!metadata.err) {
                        let language = this.props.language || metadata.country;

                        latencyHistogram = {
                            buckets: {},
                            sum: 0,
                            count: 0,
                            operationName: metadata.name,
                        }

                        this.setState({
                            metadata,
                            initialized: true,
                            language
                        });

                        this.connectWS(metadata.streamingApi, metadata.id);
                    }
                });
        }
    }

    checkState() {
        if (!this.state.initialized) {
            this.init();
        } else {
            let {streamingApi, id} = this.state.metadata;
            let {client, lastPong} = this.state;

            if (!streamingApi || !id) return;

            if (!client || (lastPong && lastPong.getTime() < new Date().getTime() - (pingIntervalSeconds + 6) * 1000)) {
                if (client) {
                    client.close();
                }
                this.connectWS(streamingApi, id);
            }
        }
    }

    updateLatencyHistogram(data, now) {
        let lag = (now.valueOf() - moment(data.time).valueOf()) / 1000.0;
        let bucket = latencyBuckets.find(b => lag <= b);

        if (bucket === Number.MAX_VALUE) {
            bucket = "+Inf";
        }

        latencyHistogram.buckets[bucket.toString()] = (latencyHistogram.buckets[bucket.toString()] || 0) + 1;
        latencyHistogram.sum = latencyHistogram.sum + lag;
        latencyHistogram.count = latencyHistogram.count + 1;
    }

    connectWS(url, id) {
        if (this.state.client) this.state.client.close();

        let client = new W3CWebSocket(`wss://${url}/occupancy`);
        this.setState({client, lastPong: null});
        let {token} = this.props;

        clearTimeout(this.state.connectionTimeout);
        let connectionTimeout = setTimeout(() => {
            if (client.readyState !== 1) {
                client.close();
                this.setState((state) => ({
                    client: (client === state.client ? null : state.client),
                    wsError: 'timeout after 30s'
                }));
            } else {
                if (this.state.client !== client) {
                    client.close();
                }
            }
        }, 30 * 1000);
        this.setState({connectionTimeout});

        client.onopen = () => {
            console.log('WebSocket Client Connected');
            if (this.state.client !== client) {
                client.close();
            } else {
                client.send(JSON.stringify({token, operation_id: id, withoutDailyData: true}));
                this.setState({connectionStatus: 'OK', wsStatus: null, wsError: null});
            }
        };
        client.onmessage = (message) => {
            if (this.state.client !== client) {
                client.close();
            } else {
                this.setState({lastPong: new Date()});
                if (message.data !== 'pong') {
                    let data = JSON.parse(message.data);
                    if(this.state.lastDataTime && data.time && moment(data.time).isBefore(moment(this.state.lastDataTime))) {
                        // streaming api is restarting
                    } else {
                        if(data.time) {
                            this.setState({lastDataTime: data.time});
                        }
                        // ignore first massage in latency histogram
                        if (this.state.data.time) {
                            this.updateLatencyHistogram(data, moment(new Date()));
                        }
                        this.setState({data});
                    }
                }
            }
        };
        client.onclose = (event) => {
            let code = "";
            if (event && event.code) code = `${event.code}`;
            let reason = "";
            if (event && event.reason) reason = `${event.reason}`;
            console.log("WebSocket Client Closed");
            this.setState((state) => ({
                client: (client === state.client ? null : state.client),
                wsStatus: code + " " + reason
            }));
        };
        client.onerror = (error) => {
            console.log("WebSocket Client Error");
            this.setState({connectionStatus: 'Error', wsError: error});
        }
    }

    componentWillUnmount() {
        document.body.style.backgroundColor = null;
        clearInterval(this.state.timer);
        clearInterval(this.state.monitoringTimer);
        clearInterval(this.state.currentTimeTimer);
        clearInterval(this.state.heartbeatTimer);
        clearTimeout(this.state.connectionTimeout);
        if (this.state.client) this.state.client.close();
    }

    getScreen() {
        let background;
        let screen;

        let {data, connectionStatus} = this.state;

        let isOverLimit = data.currentOccupancy >= data.maxOccupancy;

        let okStatus = data.currentOccupancy !== undefined && connectionStatus !== 'Error';
        background = (
          okStatus ?
            ((!data.isOpen || isOverLimit) ? '#BE0000' : '#006F15') :
            'black'
        );

        if (okStatus) {
            if (!data.isOpen) {
                screen = 'closed';
            } else if (!data.maxOccupancy) {
                screen = 'withoutLimits';
            } else {
                if (isOverLimit) {
                    screen = 'waitState';
                } else {
                    screen = 'enterState';
                }
            }
        }

        if (this.state.err) {
            screen = 'errorState';
        } else if (this.props.token === "" && !this.state.operationId.startsWith("demo")) {
            screen = 'missingToken';
        }

        return {screen, background}
    }

    updateMonitoring() {
        let {screen} = this.getScreen({...this.state, ...this.props});
        let {token, deviceId, hideNumbers} = this.props;
        let {err, operationId, data, connectionStatus, wsStatus, wsError, client} = this.state;

        if ((screen === 'waitState' || screen === 'enterState') && hideNumbers) {
            screen = screen + 'HideNumbers'
        }

        fetch('/semaphore/monitoring', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({
                isOpen: data.isOpen,
                currentOccupancy: data.currentOccupancy,
                maxOccupancy: data.maxOccupancy,
                criticalOccupancy: data.criticalOccupancy,
                lastUpdate: data.time && moment(data.time).tz('utc').toISOString(),
                currentTime: moment(new Date()).tz('utc').toISOString(),
                screen: screen,
                error: err,
                operationId: operationId,
                deviceId: deviceId,
                connectionStatus: connectionStatus,
                wsStatus: (client ? client.readyState : "") + " " + (wsStatus || ""),
                wsError: wsError ? JSON.stringify(wsError) : null,
                latencyHistogram
            })
        });

        if (latencyHistogram) {
            latencyHistogram.sum = 0;
            latencyHistogram.count = 0;
            latencyHistogram.buckets = {};
        }
    }

    render() {
        const {template} = this.state
        const templateProps = {...this.props, ...this.state, ...this.getScreen()}


        if (template === 'legacy') return <Legacy {...templateProps} />
        if (template === 'retailSummit2021') return <RetailSummit2021 {...templateProps} />
        return <Default {...templateProps} />
    }
}

export default Semaphore;
